import { SelectOption, ThemeHeaderTitleOptions } from "@thenounproject/lingo-core";

export const themeTitleSelectOptions: SelectOption<ThemeHeaderTitleOptions>[] = [
  { label: "Portal Name", value: ThemeHeaderTitleOptions.name },
  { label: "Logo", value: ThemeHeaderTitleOptions.logo },
  { label: "No Title", value: ThemeHeaderTitleOptions.none },
];
